import { type CrossClientQueryExecution, type CrossClientQueryResultStatus, CrossClientQueryResultStatuses } from '../../../../models/CrossClient'

type ProgressStatuses = Partial<Record<CrossClientQueryResultStatus, number>>

const finishedFrom = (statuses: ProgressStatuses): number =>
  (statuses[CrossClientQueryResultStatuses.SUCCEEDED] ?? 0) +
  (statuses[CrossClientQueryResultStatuses.NO_DATA] ?? 0) +
  (statuses[CrossClientQueryResultStatuses.FAILED] ?? 0)

const countedFrom = (statuses: ProgressStatuses): number => Object.values(statuses).reduce((sum, count) => sum + (count ?? 0), 0)

// The statuses cover every row and are polled faster than the list the execution came from, so they carry the total.
export const computeRunningProgress = (execution: CrossClientQueryExecution, statuses: ProgressStatuses | undefined): { done: number; total: number } => {
  if (!statuses) {
    return { done: 0, total: execution.resultCount }
  }
  return { done: finishedFrom(statuses), total: countedFrom(statuses) }
}
